import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import moment from "moment";

import { useGetFidelNeighborhoodCash } from "../../CustomHooks/Queries";

import { BackIcon, RewardsEmptyIcon } from "./nn-icons";
import { formatCurrency } from "../../Utils/helpers";

function NeighborhoodNetworkRewards() {
  const navigate = useNavigate();

  const { isLoading, data: rewards = [] } = useGetFidelNeighborhoodCash();

  return (
    <div className="nn-page rewards anim-ready">
      <section>
        <div className="max-width-container">
          <div className="nn-content-card">
            <div className="nn-card-header">
              <button type="button" className="nn-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
                <BackIcon />
              </button>
              <h1>My Rewards</h1>
              <span className="nn-header-spacer" />
            </div>
            {isLoading ? (
              <div className="loading-content">
                <CircularProgress />
              </div>
            ) : rewards.length > 0 ? (
              <>
                {rewards.map((reward, index) => (
                  <div className="fidel-reward" key={index}>
                    <div className="reward-info">
                      <div className="reward-name">{reward.merchant_name}</div>
                      <div className="reward-amount">{formatCurrency(reward.amount)}</div>
                    </div>
                    <span className="rewarded-on">{moment(reward.date).format("MMMM DD, YYYY HH:mm")}</span>
                  </div>
                ))}
              </>
            ) : (
              <div className="nn-rewards-empty">
                <div className="rewards-empty-icon mb-8">
                  <RewardsEmptyIcon />
                </div>
                <h2 className="rewards-empty-title mb-1">No Rewards Yet</h2>
                <p className="rewards-empty-message mb-6">
                  Pay with a linked card at participating neighborhood spots to start earning cash back. Your rewards
                  will show up here.
                </p>
                <button
                  type="button"
                  className="nn-link-btn"
                  onClick={() => navigate("/deals/neighborhood-network/brands-and-offers")}
                >
                  Explore Offers
                </button>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default NeighborhoodNetworkRewards;
